/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLaunchedProjectsQuery } from '../../models/get-launched-projects-query';
import { GetLaunchedProjectsQueryResult } from '../../models/get-launched-projects-query-result';

export interface ApiProjectGetLaunchedProjectsPost$Plain$Params {
      body?: GetLaunchedProjectsQuery
}

export function apiProjectGetLaunchedProjectsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectGetLaunchedProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLaunchedProjectsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetLaunchedProjectsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLaunchedProjectsQueryResult>;
    })
  );
}

apiProjectGetLaunchedProjectsPost$Plain.PATH = '/api/Project/GetLaunchedProjects';
